import { useParams } from "react-router-dom";
import SinglePage from "../components/SinglePage/SinglePage";

const SingleDynamicPage = () => {
  const { id } = useParams();
  return <SinglePage pageId={id} />;
};

export default SingleDynamicPage;
